/* Packs: "Arma tu pack" (sections/bundle-builder.liquid) y "Packs por carrera" (sections/race-packs.liquid).
   Los formularios [data-pm-multi] añaden varias líneas de una vez con /cart/add.js y luego abren el
   carrito lateral reutilizando su enlace a.pm-cart (cart-drawer.js lo refresca y lo abre). */
(function () {
  if (window.PowmixPacks) return;
  window.PowmixPacks = true;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function formatMoney(cents, format) {
    format = format || '{{amount_with_comma_separator}} €';
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* Añadir varias líneas y abrir el carrito lateral */
  function itemsFromForm(form) {
    var map = {};
    form.querySelectorAll('input[name^="items["]').forEach(function (input) {
      var m = input.name.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (!m) return;
      map[m[1]] = map[m[1]] || {};
      map[m[1]][m[2]] = parseInt(input.value, 10);
    });
    return Object.keys(map).map(function (k) { return map[k]; }).filter(function (it) { return it.id && it.quantity > 0; });
  }
  function openCart() {
    var link = document.querySelector('a.pm-cart');
    if (link && document.getElementById('CartDrawer')) { link.click(); return; }
    window.location.href = root + 'cart';
  }
  function onSubmit(e) {
    var form = e.target.closest ? e.target.closest('form[data-pm-multi]') : null;
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var items = itemsFromForm(form);
    if (!items.length) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw er; }); return r.json(); })
      .then(openCart)
      .catch(function (er) { alert((er && (er.description || er.message)) || 'No se ha podido añadir al carrito.'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  /* Fase de captura: se adelanta al carrito lateral, que escucha el submit de /cart/add en burbuja */
  document.addEventListener('submit', onSubmit, true);

  /* Arma tu pack */
  function initBuilder(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var data;
    try { data = JSON.parse(el.querySelector('[data-pm-bb-data]').textContent); } catch (err) { return; }
    var variants = data.variants || [];
    var step = variants.reduce(function (min, v) { return v.gels > 0 && v.gels < min ? v.gels : min; }, Infinity);
    if (!isFinite(step)) step = 3;
    function find(flavor, gels) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].flavor === flavor && variants[i].gels === gels) return variants[i];
      }
      return null;
    }
    var rows = Array.prototype.slice.call(el.querySelectorAll('[data-pm-bb-flavor]'));
    var counts = {};
    rows.forEach(function (row) { counts[row.getAttribute('data-pm-bb-flavor')] = 0; });

    var q = function (s) { return el.querySelector(s); };
    var sizeInputs = el.querySelectorAll('[data-pm-bb-size]');
    var progressText = q('[data-pm-bb-progress-text]');
    var bar = q('[data-pm-bb-bar]');
    var priceEl = q('[data-pm-bb-price]');
    var compareEl = q('[data-pm-bb-compare]');
    var unitEl = q('[data-pm-bb-unit]');
    var linesEl = q('[data-pm-bb-lines]');
    var hintEl = q('[data-pm-bb-hint]');
    var inputsEl = q('[data-pm-bb-inputs]');
    var submit = q('[data-pm-bb-submit]');

    function size() {
      var checked = el.querySelector('[data-pm-bb-size]:checked');
      return checked ? parseInt(checked.value, 10) : 12;
    }
    function total() {
      return Object.keys(counts).reduce(function (sum, k) { return sum + counts[k]; }, 0);
    }
    function fill(tpl, vals) {
      return (tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return vals[k] !== undefined ? vals[k] : m; });
    }
    /* Líneas de carrito según la regla: un sabor = pack de ese tamaño; varios = packs de 3 */
    function lines() {
      var s = size();
      var used = Object.keys(counts).filter(function (k) { return counts[k] > 0; });
      if (used.length === 1 && counts[used[0]] === s) {
        var pack = find(used[0], s);
        if (pack && pack.available) return { single: true, items: [{ v: pack, qty: 1 }] };
      }
      return {
        single: false,
        items: used.map(function (k) { return { v: find(k, step), qty: counts[k] / step }; })
      };
    }
    function cheapestSingle(s) {
      var best = null;
      Object.keys(counts).forEach(function (k) {
        var v = find(k, s);
        if (v && v.available && (!best || v.price < best.price)) best = v;
      });
      return best;
    }

    function render() {
      var s = size(), t = total(), money = data.money;
      /* recorta si el pack se ha hecho más pequeño */
      if (t > s) {
        Object.keys(counts).forEach(function (k) {
          var over = total() - s;
          if (over > 0) counts[k] = Math.max(0, counts[k] - Math.ceil(Math.min(over, counts[k]) / step) * step);
        });
        t = total();
      }
      rows.forEach(function (row) {
        var name = row.getAttribute('data-pm-bb-flavor');
        var base = find(name, step);
        var soldout = !base || !base.available;
        row.classList.toggle('is-soldout', soldout);
        var so = row.querySelector('.pm-bb__soldout'); if (so) so.hidden = !soldout;
        row.querySelector('[data-pm-bb-count]').textContent = counts[name];
        row.querySelector('[data-pm-bb-minus]').disabled = counts[name] <= 0;
        row.querySelector('[data-pm-bb-plus]').disabled = soldout || t + step > s;
      });
      progressText.textContent = fill(progressText.getAttribute('data-template'), { x: t, total: s });
      bar.setAttribute('aria-valuemax', s);
      bar.setAttribute('aria-valuenow', t);
      bar.firstElementChild.style.width = (s ? Math.min(100, (t / s) * 100) : 0) + '%';

      var res = lines();
      var price = 0, compare = 0;
      linesEl.innerHTML = '';
      inputsEl.innerHTML = '';
      res.items.forEach(function (it, i) {
        if (!it.v) return;
        price += it.v.price * it.qty;
        compare += (it.v.compare > it.v.price ? it.v.compare : it.v.price) * it.qty;
        var li = document.createElement('li');
        li.textContent = (it.qty > 1 ? it.qty + ' × ' : '') + it.v.gels + ' ' + (linesEl.getAttribute('data-gels') || '') + ' · ' + it.v.flavor;
        linesEl.appendChild(li);
        ['id', 'quantity'].forEach(function (f) {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'items[' + i + '][' + f + ']';
          inp.value = f === 'id' ? it.v.id : it.qty;
          inputsEl.appendChild(inp);
        });
      });
      /* Pack mezclado completo: los descuentos automáticos "Pack mezclado de 12/24/36" lo dejan al precio del pack de un sabor */
      var nFlavors = Object.keys(counts).filter(function (k) { return counts[k] > 0; }).length;
      if (t === s && t > 0 && nFlavors > 1) {
        var same = cheapestSingle(s);
        if (same && same.price < price) { compare = Math.max(compare, price); price = same.price; }
      }
      priceEl.textContent = formatMoney(price, money);
      compareEl.hidden = !(compare > price);
      compareEl.textContent = compare > price ? formatMoney(compare, money) : '';
      unitEl.textContent = t ? fill(unitEl.getAttribute('data-template'), { unit: formatMoney(Math.round(price / t), money) }) : '';

      var complete = t === s && t > 0;
      if (complete && res.single) {
        hintEl.textContent = fill(hintEl.getAttribute('data-single'), { total: s });
        hintEl.hidden = false;
      } else if (t > 0 && Object.keys(counts).filter(function (k) { return counts[k] > 0; }).length > 1) {
        var best = cheapestSingle(s);
        hintEl.textContent = best ? fill(hintEl.getAttribute('data-mixed'), { total: s, price: formatMoney(best.price, money) }) : '';
        hintEl.hidden = !best;
      } else {
        hintEl.hidden = true;
      }

      submit.disabled = !complete;
      submit.textContent = complete ? submit.getAttribute('data-ready') : fill(submit.getAttribute('data-missing'), { x: s - t });
    }

    el.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-pm-bb-plus]');
      var minus = e.target.closest('[data-pm-bb-minus]');
      if (!plus && !minus) return;
      var name = (plus || minus).closest('[data-pm-bb-flavor]').getAttribute('data-pm-bb-flavor');
      if (plus && total() + step <= size()) counts[name] += step;
      if (minus && counts[name] >= step) counts[name] -= step;
      render();
    });
    sizeInputs.forEach(function (input) { input.addEventListener('change', render); });
    render();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pm-bb]').forEach(initBuilder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
